import React from 'react';

import Img from '../../../Img';
import AddPhotoV3 from './AddPhotoV3';

import styles from '../headerV3.scss';

const BADGE_TEXT = 'COLLEGE PROSPECT';

// Bottom arc from ~7:30 to ~4:30: text sits centered underneath the photo, reading
// left → right with letter tops facing the photo. With the ±28px overlay box, this
// radius floats the letter tops well clear of the avatar's border circle.
const BADGE_TEXT_ARC = 'M 6.9 74.2 A 55 55 0 0 0 113.1 74.2';

const CollegeProspectBadgeRing = ({ 'data-testid': dataTestId }) => (
    <svg
        className={styles.badgeRing}
        viewBox="0 0 120 120"
        aria-label="College Prospect"
        data-testid={dataTestId}
    >
        <defs>
            <path id="college-prospect-badge-arc" d={BADGE_TEXT_ARC} fill="none" />
        </defs>
        <text className={styles.badgeRingText}>
            <textPath href="#college-prospect-badge-arc" startOffset="50%" textAnchor="middle">
                {BADGE_TEXT}
            </textPath>
        </text>
    </svg>
);

const AvatarV3 = (props) => {
    const {
        firstName,
        lastName,
        isOwnProfile,
        profileImage,
        showCollegeProspectBadge,
        handleUploadPhoto,
        handleUploadPhotoPhotoStart,
        handleRemoveProfilePhoto,
        'data-testid': dataTestId,
    } = props;

    return (
        <div className={`${styles.pictureContainer} ${showCollegeProspectBadge && styles.cppBadge}`} data-testid={dataTestId}>
            {showCollegeProspectBadge && (
                <CollegeProspectBadgeRing data-testid={dataTestId ? `${dataTestId}.college-prospect-badge` : undefined} />
            )}
            {profileImage ? (
                <Img
                    src={`/v1/player/${profileImage}`}
                    data-testid={dataTestId ? `${dataTestId}.image` : undefined}
                />
            ) : (
                <div className={styles.initials} data-testid={dataTestId ? `${dataTestId}.initials` : undefined}>{firstName?.[0]}{lastName?.[0]}</div>
            )}
            {isOwnProfile && (
                <AddPhotoV3
                    uploadPhoto={handleUploadPhoto}
                    uploadStart={handleUploadPhotoPhotoStart}
                    removePhoto={handleRemoveProfilePhoto}
                    hasProfileImage={!!profileImage}
                    data-testid={dataTestId ? `${dataTestId}.add-photo` : undefined}
                />
            )}
        </div>
    );
};

export default AvatarV3;
